import { defineComponent, ref, onMounted } from 'vue'
import MapPage from '@/organizations/_default/map'
import FilterInfo from '@/organizations/tsumura/default/components/FilterInfo.vue'
import FilterGroupName from '@/organizations/tsumura/default/components/FilterGroupName.vue'
import { Filters } from '@/services/Filters.ts'
import ProductModal from '@/components/common/ProductModal.vue'

export default defineComponent({
  extends: MapPage,
  components: {
    FilterInfo,
    FilterGroupName,
    ProductModal
  },
  setup(props, context) {
    const page = MapPage.setup(props, context)

    const selectedProduct = ref({})
    const productModalRef = ref(null)

    onMounted(() => {
      setTimeout(() => {
        const elements = document.querySelectorAll('.filter-info')
        elements.forEach(element => {
          const filterId = element.dataset.filterId
          element.addEventListener('click', () => {
            selectedProduct.value = Filters.findById(Filters.TYPE_SEARCH_CONDITIONS, filterId)
            productModalRef.value.open()

            storelocator.analytics.client?.send('SelectProductInfo', {
              ProductId: selectedProduct.value.id,
              ProductName: selectedProduct.value.name,
            })
          })
        })
      }, 100)
    })

    return {
      ...page,
      selectedProduct,
      productModalRef
    }
  }
})
